import React from "react";
import { useTranslation } from "react-i18next";

function MultipleChoice({
  question,
  choices,
  qKey,
  onSubmitHandler,
  selectedChoices,
  isPillView = false,
  onChange,
}) {
  const { t } = useTranslation();

  const handleChange = (e, choice) => {
    const { id } = e.target;
    const isChecked = e.target.checked;

    // Handle exclusive options
    if (choice.exclusive) {
      const newState = isChecked
        ? { [id]: { checked: true, value: choice.value, id } }
        : {};
      //   onSubmitHandler(newState);
      return;
    }

    // Handle regular options
    const newState = { ...selectedChoices };

    // Uncheck exclusive option if any regular option is selected
    const exclusiveOption = choices.find((c) => c.exclusive);
    if (exclusiveOption && isChecked) {
      delete newState[exclusiveOption.id];
    }

    // Update the current choice
    if (isChecked) {
      newState[id] = { checked: true, value: choice.value, id };
    } else {
      delete newState[id];
    }

    // onSubmitHandler(newState);
  };

  const isChecked = (choiceId) => {
    return !!selectedChoices[choiceId]?.checked;
  };

  const isResponseEmpty = () => {
    return Object.values(selectedChoices).every((choice) => !choice.checked);
  };

  return (
    <>
      <h3 className="headtitle">{question}</h3>
      <ul
        className={
          isPillView
            ? "list-unstyled list_switch_checkbox"
            : "list-unstyled list_checkbox_btn"
        }
      >
        {choices.map((choice) => (
          <li key={choice.id}>
            <label>
              <input
                type="checkbox"
                name={qKey}
                value={choice.value}
                id={choice.id}
                checked={isChecked(choice.code)}
                onChange={(e) => onChange(choice.code, e.target.checked)}
              />
              <span className="dot"></span>
              <span className="txt">{choice.text}</span>
            </label>
          </li>
        ))}
      </ul>
      <div className="btn_block bottom_button d-flex justify-content-center">
        <button
          className="btn btn_primary nextstep_cta"
          disabled={isResponseEmpty()}
          onClick={() => onSubmitHandler(selectedChoices)}
        >
          {t("login.DOBSTEP.button")}
        </button>
      </div>
    </>
  );
}

export default MultipleChoice;
